import React from 'react';
import { format } from 'date-fns';
import './StatusTimeline.css';

const ACTION_LABELS = {
  'request.submitted': 'Submitted',
  'request.submitted_on_behalf': 'Submitted on behalf',
  'request.approved': 'Approved',
  'request.denied': 'Denied',
  'request.cancelled': 'Cancelled',
  'request.removed': 'Removed',
};

function StatusTimeline({ timeline }) {
  if (!timeline || timeline.length === 0) return null;

  return (
    <div className="status-timeline">
      {timeline.map((entry, index) => (
        <div key={index} className="timeline-entry">
          <div className="timeline-connector">
            <div className={`timeline-dot ${index === timeline.length - 1 ? 'timeline-dot-current' : ''}`} />
            {index < timeline.length - 1 && <div className="timeline-line" />}
          </div>
          <div className="timeline-content">
            <span className="timeline-action">
              {ACTION_LABELS[entry.action] || entry.action}
            </span>
            {entry.user_name && (
              <span className="timeline-actor"> by {entry.user_name}</span>
            )}
            <span className="timeline-date">
              {format(new Date(entry.created_at), 'MMM d, yyyy h:mm a')}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StatusTimeline;
